export default "__VITE_ASSET__090ec06d__"